import React from 'react';
import { motion } from 'framer-motion';

export const MetricsSection = () => {
  return (
    <section className="py-16 md:py-20" style={{ background: 'linear-gradient(to bottom right, #0c69ac, #004e89, #003d6b)' }}>
      <div className="container-portico">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center"
        >
          <p className="text-white/90 font-semibold text-sm tracking-widest uppercase mb-4">
            Entrance Systems & Performance Flooring, Built Tough
          </p>
          
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Durability. Safety. Design. <span className="whitespace-nowrap">No tradeoffs.</span>
          </h2>
          
          <p className="text-lg md:text-xl text-white/90 leading-relaxed">
            Transform your commercial space with entrance systems and commercial flooring solutions
            that perform as hard as you do. From grocery store flooring and retail flooring installation
            to non-slip kitchen flooring and national flooring rollouts, we deliver safer floors that
            protect your investment and elevate your brand.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default MetricsSection;
